export default __webpack_public_path__ + "static/media/Roobert-SemiBold.c3c07cfd.woff";